import Handlebars from "utilities/vendor/handlebars/4.0.5/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.0.5/js/handlebars";
import "utilities/vendor/picturefill/3.0.2/js/picturefill.min";









'use strict';


const viewports = [
  'custom',
  'xxlarge',
  'xlarge',
  'large',
  'medium',
  'small',
];







const smallMinWidth = 1;
const mediumMinWidth = 768;
const largeMinWidth = 1025;
const xlargeMinWidth = 1440;
const xxlargeMinWidth = 1921;

const mediaQueriesList = {
  small: `only screen and (min-width:${smallMinWidth}px)`,
  medium: `only screen and (min-width:${mediumMinWidth}px)`,
  large: `only screen and (min-width:${largeMinWidth}px)`,
  xlarge: `only screen and (min-width:${xlargeMinWidth}px)`,
  xxlarge: `only screen and (min-width:${xxlargeMinWidth}px)`,
};











function generateSourceString(source, viewport, custom) {


  if (typeof custom === 'undefined') {
    custom = false; 
  }


  if (custom && !source.media) {
    return false;
  }


  let attributes = '';


  const media = `media="${source.media ? source.media : mediaQueriesList[viewport]}"`;



  Object.keys(source).forEach((attr) => {

    if (attr !== 'srcset' && attr !== 'media') {
      attributes += ` ${attr}="${source[attr]}"`;
    } else if (attr === 'srcset') {
      attributes += ` srcset="${source.srcset.join(',')}"`;
    }
  });


  return `<source ${media}${attributes}>`;
}








function generateSourceTags(sources) {

  const sourceStrings = [];


  viewports.forEach(function itertateThroughViewports(viewport) {

    if (sources[viewport]) {

      if (viewport === 'custom') {

        sources[viewport].forEach(function iterateThroughCustomViewports(customViewport) {
          sourceStrings.push(generateSourceString(customViewport, viewport, true));
        });
      } else if (sources[viewport] instanceof Array) {

        sources[viewport].sort(function sortWebpFirst(a) {
          return (a.type && a.type === 'image/webp') ? -1 : 1;
        }).forEach(function iterateThroughViewports(sourceViewport) {
          sourceStrings.push(generateSourceString(sourceViewport, viewport));
        });
      } else if (sources[viewport] instanceof Object) {
        sourceStrings.push(generateSourceString(sources[viewport], viewport));
      }
    }
  });


  return sourceStrings;
}






function generateAttributes(attrs) {
  const attributes = [];

  Object.keys(attrs).forEach((key) => {
    attributes.push(`${key}="${attrs[key]}"`);
  });

  return attributes.join(' ');
}








function generateImageTag(sources) {
  const attributes = sources.imageAttributes || {};



  if (!attributes.alt) {
    Object.assign(attributes, {
      alt: sources.alt || '',
    });
  }

  const attrs = generateAttributes(attributes);

  return `<img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" ${attrs}/>`;
}





const helpers = {





  picture: function pictureHelper(sources) {
    if (sources) {
      const tag = '<picture>';
      const closingTag = '</picture>';
      const fallbackImg = generateImageTag(sources);












      const sourceTags = generateSourceTags(sources);

      return new Handlebars.SafeString(`${tag}${sourceTags.join('')}${fallbackImg}${closingTag}`);
    }

    throw new Error('No image sources provided to picture helper.');
  },
};





class pictureHelper {





  static register(Handlebars) {
    Object.keys(helpers).forEach((key) => {
      Handlebars.registerHelper(key, helpers[key]);
    });
  }
}

module.exports = pictureHelper;
